import { Component, OnInit, ViewContainerRef,Output, EventEmitter } from '@angular/core';
import { FormBuilder, FormGroup, ValidatorFn, ValidationErrors, AbstractControl } from '@angular/forms';
import { AnnuaireProfessionnelsSanteService } from 'src/app/services/annuaire-professionnels-sante/annuaire-professionnels-sante.service';
import { CorrespondantService } from 'src/app/services/correspondant/correspondant.service';
import { ModalService } from 'src/app/services/modal/modal.service';
import { PractitionerSearchParams } from 'src/app/services/mss/mss-service.abstract';
import { HeaderCommunicationService } from 'src/app/services/node/header-communication.service';
import { ReferentielService } from 'src/app/services/referentiel/referentiel.service';
import { ReferentielEnum } from 'src/app/utils/enums/referentiel-enum';
import { AnnuaireResultCorrespondant } from 'src/app/utils/interfaces/new/annuaire-result-correspondant.interface';
import { CorrespondantFilter } from 'src/app/utils/interfaces/new/filtre-correspondant.interface';
import { Header } from 'src/app/utils/interfaces/new/header.interface';
import { InfoAnnuaire } from 'src/app/utils/interfaces/new/info-annuaire.interface';
import { Practitioner } from 'src/app/utils/interfaces/new/Practitioner';
import { PractitionerSearchResult } from 'src/app/utils/interfaces/new/PractitionerSearchResult';
import { Referentiel } from 'src/app/utils/interfaces/new/referentiel.interface';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MedecinSpecialities, PharmacienSpecialities, ChirDentisteSpecialities } from '../../../services/cpx-handle/cpx-handle-utils.service';
import { Inject } from '@angular/core';
import { MssServiceFactory } from 'src/app/services/mss/mss-service.factory';
import { PractitionerSearchResultApi } from 'src/app/utils/interfaces/new/PractitionerSearchResultApi';
import { SnackbarService } from 'src/app/services/snackbar/snackbar.service';

const PROFESSION_OID = '1.2.250.1.71.1.2.7';
const SPECIALITE_OID = '1.2.250.1.71.4.2.5';

export function atLeastOneFieldValidator(): ValidatorFn {
  return (group: AbstractControl): ValidationErrors | null => {
    const hasValue = Object.values(group.value).some(value => {
      return typeof value === 'string'
        ? value.trim() !== ''
        : value !== null && value !== undefined;
    });

    return hasValue ? null : { atLeastOne: true };
  };
}

@Component({
  selector: 'app-annuaire',
  templateUrl: './annuaire.component.html',
  styleUrls: [
    './annuaire.component.scss',
    '../modal.fragment.scss'
  ]
})

export class AnnuaireComponent implements OnInit {
  @Output() closeEmitter = new EventEmitter<void>();

  public displayCorrespondant: boolean = false;

  public refSpecialite: Referentiel[];
  public refProfession: Referentiel[];
  public correspondantsFiltred: AnnuaireResultCorrespondant[];
  public correspondantInfos: AnnuaireResultCorrespondant;
  public specialiteName: string;

  public searchCorrespondantForm: FormGroup;
  public selectedTabIndex = 0; // 0 = Local, 1 = Apicrypt, 2 = En Ligne
  public formGroup:FormGroup;
  public isSearching:boolean = false;
  public result: PractitionerSearchResult;
  public resultApi: PractitionerSearchResultApi;
  public specialites: {
    id: string;
    libelle: string;
  }[];

  constructor(
    private _builder: FormBuilder,
    public _ref: ReferentielService,
    private _view: ViewContainerRef,
    private _modal: ModalService,
    public _correspondant: CorrespondantService,
    private _send: HeaderCommunicationService,
    private _annuaireProSrv: AnnuaireProfessionnelsSanteService,
    private _mssSrv: MssServiceFactory,
    private _snack: SnackbarService,
    public dialogRef: MatDialogRef<AnnuaireComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    const head: Header = {
      isBack: true,
      title: "Recherche annuaire externe des correspondants",
      backPage: "correspondant"
    };
    this._send.announceHeader(head);
  }

  async ngOnInit(): Promise<void> {
    this.refSpecialite = await (await this._ref.findRefListTableHypermed(ReferentielEnum.subjectrole_dmp))
      .map((qualite) => { return { id: qualite.id, libelle: qualite.libelle } });
    this.refProfession = await (await this._ref.findRefListTableHypermed(ReferentielEnum.subjectrole_dmp))
      .map((qualite) => { return { id: qualite.id, libelle: qualite.libelle } });

    this.searchCorrespondantForm = this._builder.group({
      speciality: [],
      nom: [],
      codePostal: [],
      ville: []
    }, { validators: atLeastOneFieldValidator() });

    this.formGroup = this._builder.group({
      exerciceName: [''],
      firstName: [''],
      rpps: [''],
      profession: [''],
      speciality: [''],
      structureOrAddress: [''],
      zip: [''],
      city: [''],
      email: [''],  
    }, { validators: atLeastOneFieldValidator() });

    this.specialites = [
      { id: '', libelle: 'Toutes les spécialités' },
      ...MedecinSpecialities.map(s => ({ id: s.code, libelle: s.libelle })),
      ...PharmacienSpecialities.map(s => ({ id: s.code, libelle: s.libelle })),
      ...ChirDentisteSpecialities.map(s => ({ id: s.code, libelle: s.libelle }))
    ].sort((a, b) => a.id === '' ? -1 : (b.id === '' ? 1 : a.libelle.localeCompare(b.libelle)));
  }

  public async openDetails(correspondant: AnnuaireResultCorrespondant) {
    console.log(correspondant);
    this.correspondantInfos = correspondant;
    /**
     * TODO Les spécialités récupérées ici ne sont pas les bonnes
     * Elles ont des id de type uuid
     * alors que le correspondant a un idSpecialite de type {code}++{codeSystem}
     */
    if (correspondant.idSpecialite && correspondant.idSpecialite !== ''
      && (!correspondant.specialiteName || correspondant.specialiteName === '')) {
      this.specialiteName = this.refSpecialite.find(x => x.id === correspondant.idSpecialite)?.libelle || '';
    } else {
      this.specialiteName = correspondant.specialiteName;
    }
    if (!correspondant.email2 && correspondant.rpps) {
      const ldapFilter: PractitionerSearchParams = {
        rpps: correspondant.rpps
      };
      const ldapKeys = Object.keys(ldapFilter);
      const atLeastOneValidField = ldapKeys.find(k => ldapFilter[k] !== undefined && ldapFilter[k] !== null && ldapFilter[k] !== '');
      if (atLeastOneValidField) {
        const load = this._modal.openLoading(this._view);
        try {
          const tmp = await this._annuaireProSrv.searchProfessionals(ldapFilter, -1, 0, true);
          if (tmp.result && tmp.result.length > 0) {
            this.correspondantInfos.email2 = '';
            for (const mssAddress of tmp.result) {
              this.correspondantInfos.email2 += mssAddress.msSanteAddress + ',';
            }
          }
        } catch (error) {
          console.error(error);
        } finally {
          this._modal.close(load);
        }
      }
    }
    const modal = this._modal.openInfoCorrespondant(this._view, this.correspondantInfos);
    const sub = modal.instance.closeEmitter.subscribe(async (x) => {
      if (x) {
        const load = this._modal.openLoading(this._view);
        await this.recordCorrespondant(x)
        this._modal.close(load);
      }
      this._modal.close(modal);
      sub.unsubscribe();
    });
  }

  public async submitSearchCorrespondant() {
    this.cleanInfosCorrespondant();
    this.searchCorrespondantForm.markAllAsTouched();
    if (this.searchCorrespondantForm.valid) {
      const modal = this._modal.openLoading(this._view);
      try {
        const selectedSpeciality: string = this.searchCorrespondantForm.get('speciality').value;
        const name: string = this.searchCorrespondantForm.get('nom').value;
        const city: string = this.searchCorrespondantForm.get('ville').value;
        const postalCode: string = this.searchCorrespondantForm.get('codePostal').value;

        const filtreCorrespondant: CorrespondantFilter = {
          nom: name || undefined,
          codePostal: postalCode || undefined,
          ville: city || undefined,
          idSpecialite: selectedSpeciality || undefined,
        };
        this.correspondantsFiltred = (await this._correspondant.correspondantsSearchFilters(filtreCorrespondant)).map((x) => {
          const result: AnnuaireResultCorrespondant = {
            ...x,
            isFromAnnuaire: false
          };
          return result;
        });

        const filtreAnnuaire: InfoAnnuaire = {
          nom: name || undefined,
          codePostal: postalCode || undefined,
          commune: city || undefined,
          specialite: selectedSpeciality ? selectedSpeciality.split('++')[0] : undefined,
          prenom: undefined,
        }

        // const paginatorFilter: Filtres = {currentPage: 1, perpage: 15};

        if (filtreAnnuaire?.nom?.length >= 3 || filtreAnnuaire?.codePostal?.length >= 2 || filtreAnnuaire?.commune?.length >= 3 || filtreAnnuaire?.specialite) {
          const listFromAnnuaire = (await this._annuaireProSrv.searchAnnuaireSante(filtreAnnuaire)).objects;
          this.correspondantsFiltred.push(...listFromAnnuaire.map(x => {
            const result: AnnuaireResultCorrespondant = {
              rpps: x.rpps,
              adresse1: x.adresse,
              codePostal: x.codePostal,
              ville: x.commune,
              email1: x.email,
              nom: x.nom,
              prenom: x.prenom,
              telephone1: x.telephone ? x.telephone.replace(/\./g, '').replace(/ /g, '') : undefined,
              titre: x.titre,
              idSpecialite: `${x.specialite}++${SPECIALITE_OID}`,
              specialiteName: x.specialite ? this._getSpecialityLabelFromId(`${x.specialite}++${SPECIALITE_OID}`) : undefined,
              idProfession: `${x.profession}++${PROFESSION_OID}` ,
              professionName: x.profession ? this._getProfessionLabelFromId(`${x.profession}++${PROFESSION_OID}`) : undefined,
              isFromAnnuaire: true,
              categorie: x.categorie,
            }
            return result;
          }));
        }


        this.correspondantsFiltred.sort((a, b) => a.nom > b.nom ? 1 : -1);
      } catch (error) {
        console.error(error);
      } finally {
        this._modal.close(modal);
      }

      // Ancien système de recherche dans le LDAP MSS
      // const specLabel = this._getSpecialityLabelFromId(selectedSpeciality);
      // const ldapFilter: PractitionerSearchParams = {
      //   city: city && city !== '' ? city : undefined,
      //   practitionerName: name && name !== '' ? name : undefined,
      //   profession: specLabel && specLabel !== '' ? specLabel : undefined,
      //   zip: postalCode && postalCode !== '' ? postalCode : undefined,
      // };

      // // On fait la recherche annuaire (LDAP) puis on ajoute le résultat à la recherche correspondants
      // const ldapKeys = Object.keys(ldapFilter);
      // const atLeastOneValidField = ldapKeys.find(k => ldapFilter[k] !== undefined && ldapFilter[k] !== null && ldapFilter[k] !== '');
      // if (atLeastOneValidField) {
      //   const tmp = await this._annuaireProSrv.searchProfessionals(ldapFilter, -1, 0, true);
      //   const mapped = tmp.result.map(r => this._mapPractitionerSearchResultToAnnuaireResultCorrespondant(r));
      //   this.correspondantsFiltred.objects = this.correspondantsFiltred.objects.concat(mapped);
      // }

    }
  }

  private _mapPractitionerSearchResultToAnnuaireResultCorrespondant(result: Practitioner): AnnuaireResultCorrespondant {
    return {
      nom: result.practitionerName,
      prenom: result.firstName,
      codePostal: result.zip,
      ville: result.city,
      email1: result.msSanteAddress,
      specialiteName: result.profession
    };
  }

  private _getSpecialityLabelFromId(id: string): string {
    let rtd = '';
    if (id && id !== '') {
      const tmp = this.refSpecialite.find(s => s.id === id);
      rtd = tmp ? tmp.libelle : '';
    }
    return rtd;
  }

  private _getProfessionLabelFromId(id: string): string {
    let rtd = '';
    if (id && id !== '') {
      const tmp = this.refSpecialite.find(s => s.id === id);
      rtd = tmp ? tmp.libelle : '';
    }
    return rtd;
  }

  public cleanInfosCorrespondant() {
    this.correspondantInfos = undefined;
  }

  public async recordCorrespondant(correspondant: AnnuaireResultCorrespondant) {
    const loader = this._modal.openLoading(this._view);
    try {
      // TODO WTF ON RAPPATRIE TOUT LES CORRESPONDANTS !!!!!!
      // const dbCorresCabinet = await this._correspondant.find();

      // let filtredCorres = -1;
      // if ((!correspondant.id || correspondant.id === '') && correspondant.nom && correspondant.prenom && correspondant.codePostal) {
      //   filtredCorres = dbCorresCabinet.findIndex(x =>
      //     x.nom === correspondant.nom && x.prenom === correspondant.prenom && x.codePostal === correspondant.codePostal);
      // }

      // if (filtredCorres >= 0) {
      //   this._modal.openAlert(this._view, 'Information', 'Le correspondant est déjà enregistré dans votre annuaire.');
      //   this._modal.close(loader);
      // } else {

      const dbCorres = [correspondant];
      correspondant.isAdresseMssFromAnn = true;
      correspondant.isCategorieFromAnn = true;
      correspondant.isFromAnnuaire = true;
      correspondant.isNomFromAnn = true;
      correspondant.isPrenomFromAnn = true;
      correspondant.isProfessionFromAnn = true;
      correspondant.isRppsFromAnn = true;
      correspondant.isSpecialiteFromAnn = true;
      await this._correspondant.create(dbCorres);
      this._snack.openSnackBar('Le correspondant a été ajouté à votre annuaire.');

      // }
    } catch (e) {
      console.error(e);
      this._snack.openSnackBarError(e.message);
    }finally{
      this._modal.close(loader);
    }
  }

  public redirectToSiteAnnuaire() {
    window.open('https://annuaire.sante.fr');
  }
  public redirectToSiteAnnuaireApi() {
    window.open('https://apicrypt.org/annuaire');
  }

  public closeModal(value = undefined): void {
    this.dialogRef.close();
  }

  public async doSearchRecipients(forceSearch = true, page = 1): Promise<void> {
    const practitionerName = this.formGroup.get('exerciceName')?.value?.trim() || '';
    const firstName = this.formGroup.get('firstName')?.value?.trim() || '';
    const profession = this.formGroup.get('profession')?.value?.trim() || '';
    const speciality = this.formGroup.get('speciality')?.value?.trim() || '';
    const rpps = this.formGroup.get('rpps')?.value?.trim() || '';
    const structureOrAddress = this.formGroup.get('structureOrAddress')?.value?.trim() || '';
    const zip = this.formGroup.get('zip')?.value?.trim() || '';
    const city = this.formGroup.get('city')?.value?.trim() || '';
    const emailMSS = this.formGroup.get('email')?.value?.trim() || '';

    if(!this.isSearching){
      try {
        this.isSearching = true;
        this.result = await this._mssSrv.getService().findMSSRecipient({
            city,
            zip, 
            structureOrAddress,
            emailMSS,
            firstName,
            practitionerName,
            profession,
            speciality,
            rpps
          },
          40, //limite par page
          page - 1,
          forceSearch
        );
        this._initTableDisplay(this.result);
      } catch (e) {
        console.error(e);
        this._modal.openAlert(
          this._view,
          'Erreur',
          e?.error?.message || e.message
        );
      } finally {
        this.isSearching = false;
      }
    }
  }

  private _initTableDisplay(practictioners: PractitionerSearchResult): void {
    this.correspondantsFiltred = [];
    this.correspondantsFiltred.push(...practictioners.result.map(x => {
            const result: AnnuaireResultCorrespondant = {
              rpps: x.rpps,
              adresse1: x.address,
              codePostal: x.zip,
              ville: x.city,
              email2: x.msSanteAddress,
              nom: x.practitionerName,
              prenom: x.firstName,
              idSpecialite: `${x.codeSpecialite}++${SPECIALITE_OID}`,
              specialiteName: x.codeSpecialite ? this._getSpecialityLabelFromId(`${x.codeSpecialite}++${SPECIALITE_OID}`) : undefined,
              idProfession: `${x.codeProfession}++${PROFESSION_OID}` ,
              professionName: x.codeProfession ? this._getProfessionLabelFromId(`${x.codeProfession}++${PROFESSION_OID}`) : undefined,
              isFromAnnuaire: true,
            }
            return result;
          }));
    this.trierCorrespondants();
  }

  private _initTableDisplayApi(practictioners: PractitionerSearchResultApi): void {
    this.correspondantsFiltred = [];
    this.correspondantsFiltred.push(...practictioners.result.map(x => {
            const result: AnnuaireResultCorrespondant = {
              rpps: x.rpps,
              codePostal: x.zip,
              ville: x.city,
              adresseApiCrypt: x.mail,
              nom: x.practitionerName,
              prenom: x.firstName,
              infos:x.specialite,
            }
            return result;
          }));
    this.trierCorrespondants();
  }

  private trierCorrespondants() {
    this.correspondantsFiltred.sort((a, b) => {
      const nomA = (a.nom || '').toLowerCase();
      const nomB = (b.nom || '').toLowerCase();
      const prenomA = (a.prenom || '').toLowerCase();
      const prenomB = (b.prenom || '').toLowerCase();

      const cmpNom = nomA.localeCompare(nomB);
      return cmpNom !== 0 ? cmpNom : prenomA.localeCompare(prenomB);
    });
  }

  public onTabChanged(index: number): void {
    this.selectedTabIndex = index;
    this.correspondantsFiltred = null;
    this.result = {
      troncated: false,
      result: [],
      page: 1,
      perpage: 20,
      total: 0
    };
    this.isSearching = false;
  }

  public async doSearchRecipientsApi(forceSearch = true, page = 1): Promise<void> {
    const practitionerName = this.formGroup.get('exerciceName')?.value?.trim() || '';
    const firstName = this.formGroup.get('firstName')?.value?.trim() || '';
    const specialite = this.formGroup.get('professionSpeciality')?.value?.trim() || '';
    const postalCode = this.formGroup.get('zip')?.value?.trim() || '';
    const ville = this.formGroup.get('city')?.value?.trim() || '';
    const departement = '';

    if(!this.isSearching){
      try {
        this.isSearching = true;
        this.resultApi = await this._mssSrv.getService().findMSSRecipientApi({
            ville,
            firstName,
            practitionerName,
            specialite,
            postalCode,
            departement,
          },
          40, //limite par page
          page - 1,
          forceSearch
        );
        this._initTableDisplayApi(this.resultApi);
      } catch (e) {
        console.error(e);
        this._modal.openAlert(
          this._view,
          'Erreur',
          e?.error?.message || e.message
        );
      } finally {
        this.isSearching = false;
      }
    }
  }

  public resetSearchForm(): void {
    this.formGroup.reset();
    this.searchCorrespondantForm.reset();
  }

  get isformGroupDirty(): boolean {
    return this.formGroup && Object.values(this.formGroup.controls).some(control => control.dirty);
  }
  get isSearchFormDirty(): boolean {
    return this.searchCorrespondantForm && Object.values(this.searchCorrespondantForm.controls).some(control => control.dirty);
  }
}
